import styled, { keyframes } from 'styled-components';
import {
  colors,
  body2,
  smallShadow,
  backgroundColors,
  spacing,
  easing,
  duration,
  caption,
} from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const ICON_SIZE_28 = 28;
export const TEXTAREA_FIELD_CSS_RIGHT = 10;
export const INPUT_FIELD_CSS_RIGHT = 33;

// KEYFRAMES
export const scaleIn = keyframes`
    0% {
        transform: scale(0)
    }
    100% {
        transform: scale(1)
    }
`;

export const fadeInScale = keyframes`
    0% {
        opacity: 0;
        scale(0.8);
    }
    100% {
        opacity: 1;
        scale(1);
    }
`;

export const fadeIn = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

export const fadeInOut = keyframes`
  0% {
      opacity: 1;
  }
  50% {
    opacity: 0.5
  }
  100% {
    opacity: 0;
  }
`;

export const StyledCopyAssistButton = styled.div`
  text-align: right;
  position: absolute;
  top: ${pxToRem(0)};
  right: ${spacing.base};
  cursor: pointer;
  z-index: 2;
  opacity: 0;
  animation-name: ${fadeIn};
  animation-duration: ${duration.long};
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
`;

export const StyledGenerateAiIcon = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const StyledCopyAssistBtnText = styled.div`
  ${body2}
  color: ${colors.purple100};
  display: inline-block;
  align-items: center;
  padding-left: ${pxToRem(5)};
`;

export const StyledBtnWrapper = styled.div`
  ${smallShadow}
  border-radius: ${pxToRem(50)};
  max-width: ${pxToRem(ICON_SIZE_28)};
  max-height: ${pxToRem(ICON_SIZE_28)};

  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  transition: all ${duration.long} ${easing.standard};
  background: ${backgroundColors.backgroundPrimary};
  padding: ${spacing.threeEights};

  &[data-text-max-width] {
    &:hover {
      max-width: ${pxToRem(250)};
      padding: ${spacing.threeEights} ${spacing.half};
    }
  }
`;

export const StyledCopyAssistButtonText = styled.div`
  ${body2}
  color: ${colors.purple100};
  display: inline-block;
  align-items: center;
  padding-left: ${pxToRem(5)};
`;

export const CopyAssistDropdownErrorWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: ${pxToRem(40)} 0 ${pxToRem(40)} 0;
`;

export const StyledDropdownErrorTitle = styled.span`
  ${body2};
  color: ${colors.textPrimary};
`;

export const StyledDropdownErrorMessage = styled.span`
  ${caption};
  color: ${colors.textSecondary};
`;
